import moment from "moment";
import { getDefaultFilterTimeValue } from "./components/filterTime.vue";

export enum FilterType {
    project = 'project',
    plan = 'plan',
    task = 'task',
}

export enum HtmlType {
    input = 'input',
    select = 'select',
    dateTime = 'datetime',
    area = 'area',
    tree = 'tree',
    commonTree = 'commontree',
    amount = 'bigdecimal',
    userSelect = 'userselect',
}

export enum JavaType {
    bigDecimal = 'bigdecimal',
    int = 'int',
    double = 'double',
}

export enum BusinessType {
    fusionFilter = 'fusionFilter',
    projectRule = 'projectRule',
    taskRule = 'taskRule',
}

export interface SubmitParams {
    field?: string,
    rule?: string,
    val?: any,
    type?: FilterType,
    dbType?: string,
    filterLabels?: FilterLabels,
}

export interface CustomInterface {
    prjId?: string,
    executorId?: string,
}

export interface InitialParams {
    filterType: string,
    encodeParams?:  boolean,
    initialValue?: Array<any>, 
    initialMaxLength?: number,
    customParams?: CustomInterface,
    needLabel?: boolean,
    businessType?: BusinessType,
    searchFn?: Function,
    // 是否展示其他空的筛选项开关
    isShowExtraVacuousList?: boolean,
    // 需要屏蔽的字段列表
    excludeFields?: string[],
    disableDefaultValues?: boolean,
}

export interface filterGenerateParams {
    ruleContentDTO: any,
    restoreNeedParams?: Array<any>,
    selectedLabels?: FilterLabels[],
}

export interface executorRuleParams extends filterGenerateParams {
  executorAutoFlag: boolean,
  parentExecutorAutoFlag: boolean,
  receiverType: 'doctor' | 'represent',
}

export const valCanBeNullRules = ['is_not_null', 'is_null']

export interface FilterLabels {
    fieldLabel: string,
    ruleLabel: string,
    valueLabel: Array<string | number> | string | number,
}

export const hasLabelAndValueComps: (needLabel: boolean) => HtmlType[] = (needLabel) => {
    if (needLabel) {
        return [HtmlType.select, HtmlType.area, HtmlType.tree, HtmlType.commonTree, HtmlType.userSelect]
    }
    // area、tree、commonTree默认包含label
    return [HtmlType.area, HtmlType.tree, HtmlType.commonTree]
}

// 当下发的参数不要为valueKey, 需要为customKey, 而customKey又不唯一
export function whetherSubmitLabel(returnParameterMapping) {
    const { valueKey, customValueKey } = (returnParameterMapping || {});
    return !!customValueKey && customValueKey !== valueKey;
}

export function translateLabels(arr: Array<FilterLabels & {htmlType: HtmlType}>) {
    return arr.map(item => {
        let valueLabel = item.valueLabel;
        if (Array.isArray(item.valueLabel) && item.valueLabel.length) {
            if (item.htmlType === HtmlType.dateTime) {
                const noHourTimes = item.valueLabel.map(labelItem => moment(labelItem).format('YYYY-MM-DD'));
                valueLabel = noHourTimes.join('~');
            } else if (item.htmlType === HtmlType.amount) {
                valueLabel = item.valueLabel.join('至');
            } else {
                valueLabel = item.valueLabel.join('、');
            }
        }

        return {
            ...item,
            valueLabel,
        };
    })
}

// 各个组件的配置默认值方法预留
export function getDefaultValue(column) : SubmitParams {
    if (column.htmlType === HtmlType.dateTime) {
        return getDefaultFilterTimeValue(column)
    }
}
